import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { OwnedCardRow } from './OwnedCardRow/index.tsx';
import type { LazyAllLastOwnedCardsQuery_anyCard } from './__generated__/fragments.graphql.ts';

export const LazyAllLastOwnedCardsFragment = gql`
  fragment LazyAllLastOwnedCardsQuery_anyCard on AnyCardInterfaceConnection {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      slug
      inSeasonEligible
      ...OwnedCardRow_anyCard
    }
  }
  ${OwnedCardRow.fragments.anyCard}
` as TypedDocumentNode<LazyAllLastOwnedCardsQuery_anyCard>;
